import { RegistrationForm } from "@/features/hca-public-registrace";
import { PublicShellWithDiagnoza } from "@/route-helpers/public-shell-with-diagnoza";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/registrace/$terminId")({
  component: RegistraceRoute,
});

function RegistraceRoute() {
  const { terminId } = Route.useParams();
  return (
    <PublicShellWithDiagnoza>
      <RegistrationForm terminId={terminId} />
    </PublicShellWithDiagnoza>
  );
}
